// Note: On local machine this function might not work properly because of CORS restrictions.
// To test it properly disable CORS in your browser or test it on a server.
export const downloadHref = async (url: string, fileName: string) => {
  const response = await fetch(url)
  const blob = await response.blob()
  const downloadUrl = window.URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = downloadUrl
  anchor.download = fileName
  document.body.appendChild(anchor)
  anchor.click()
  window.URL.revokeObjectURL(downloadUrl)
  document.body.removeChild(anchor)
}
